import cx from "classnames";
import Link from "next/link";
import { useTranslation } from "next-i18next";

import { LINKS } from "@/constants/links";
import { useProfile } from "@/hooks/profile";
import { authStatusFromProfileQuery } from "@/hooks/useProfile";

import header from "../header.module.css";
import sidebar from "./sidebar.module.css";

export const AccessMenu = ({ menu = false }) => {
  const { t } = useTranslation("header");

  const profile = useProfile();
  const { isLoggedIn } = authStatusFromProfileQuery(profile);

  if (isLoggedIn)
    return (
      <Link
        href={LINKS.ACCOUNT}
        className={cx(header.access, { [sidebar.access]: menu })}
      >
        {t("access.account")}
      </Link>
    );

  return (
    <ul
      className={cx(header.list, header.access, {
        [sidebar.access]: menu,
      })}
    >
      <li>
        <Link href={LINKS.LOGIN}>{t("access.register")}</Link>
      </li>
      <li>
        <Link href={LINKS.LOGIN}>{t("access.login")}</Link>
      </li>
    </ul>
  );
};
